<template>
  <div class="min-h-screen bg-[#f9fafb] px-4 pb-20 pt-5">
    <div class="mb-6 flex items-center gap-3">
      <button
        aria-label="Go Back"
        @click="$router.back()"
      >
        <i class="fas fa-arrow-left text-xl text-[#1C103B]" />
      </button>
      <h1 class="text-xl font-semibold text-[#1C103B]">
        Live Sessions
      </h1>
    </div>

    <h2 class="text-lg font-semibold text-[#1C103B] mb-4">
      Live Now
    </h2>

    <div class="flex gap-3 mb-8 overflow-x-scroll pb-2 custom-scroll-bar">
      <SessionCard
        v-for="session in liveSessions"
        :key="session.id"
        :session="session"
        :is-live="true"
        class="flex-shrink-0 w-[calc(50vw-26px)]"
      />
    </div>

    <h2 class="text-lg font-semibold text-[#1C103B] mb-4">
      For you
    </h2>

    <div
      class="flex gap-2 overflow-x-auto whitespace-nowrap mb-6 custom-scroll-bar"
    >
      <button
        v-for="tag in filterTags"
        :key="tag"
        :class="[
          'px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200',
          selectedTag === tag
            ? 'bg-blue-600 text-white'
            : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50',
        ]"
        @click="selectedTag = tag"
      >
        {{ tag }}
      </button>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <SessionCard
        v-for="session in filteredForYouSessions"
        :key="session.id"
        :session="session"
        :is-live="false"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import SessionCard from "@/components/live/SessionCard.vue";

const DUMMY_IMAGE_URLS = [
    "https://unsplash.it/800/600?random=1&gravity=center",
    "https://unsplash.it/800/600?random=2&gravity=center",
    "https://unsplash.it/800/600?random=3&gravity=center",
    "https://unsplash.it/800/600?random=4&gravity=center",
    "https://unsplash.it/800/600?random=5&gravity=center",
    "https://unsplash.it/800/600?random=6&gravity=center",
];

const liveSessions = ref([
  {
    id: 1,
    title: "FUN ANIMAL FACTS LIVE QUIZ",
    host: "Ms Dina",
    image: DUMMY_IMAGE_URLS[0], 
    attendees: 102,
    tag: "Biology",
  },
  {
    id: 2,
    title: "SIMPLE SCIENCE EXPERIMENTS AT HOME",
    host: "Ms Fazrinee",
    image: DUMMY_IMAGE_URLS[1], 
    attendees: 102,
    tag: "Science",
  },
  {
    id: 3,
    title: "LOREM IPSUM DOLOR SIT AMET",
    host: "Mr. Alex",
    image: DUMMY_IMAGE_URLS[2], 
    attendees: 1200,
    tag: "Math",
  },
  {
    id: 7,
    title: "VUE.JS & TAILWIND ESSENTIALS",
    host: "Mr. Budi",
    image: DUMMY_IMAGE_URLS[3], 
    attendees: 550,
    tag: "Trending",
  },
  {
    id: 8,
    title: "HISTORY OF JAVA PROGRAMMING",
    host: "Ms. Yuni",
    image: DUMMY_IMAGE_URLS[4], 
    attendees: 320,
    tag: "History",
  },
]);

const allForYouSessions = ref([
  {
    id: 4,
    title: "MATH MAGIC TRICKS",
    host: "Agenata Jordania",
    image: DUMMY_IMAGE_URLS[5], 
    attendees: 102,
    tag: "Math",
  },
  {
    id: 5,
    title: "GUESS THE SOUND GAME",
    host: "Agenata Jordania",
    image: DUMMY_IMAGE_URLS[0],
    attendees: 102,
    tag: "Language",
  },
  {
    id: 6,
    title: "HISTORY OF ROMAN EMPIRE",
    host: "Mr. Smith",
    image: DUMMY_IMAGE_URLS[1],
    attendees: 85,
    tag: "History",
  },
  {
    id: 9,
    title: "CODING FOR BEGINNERS",
    host: "Ms. Sarah",
    image: DUMMY_IMAGE_URLS[2],
    attendees: 120,
    tag: "Trending",
  },
]);

const filterTags = ["Trending", "Math", "Biology", "History", "Language"];
const selectedTag = ref("Trending");

const filteredForYouSessions = computed(() => {
  if (selectedTag.value === "Trending") {
    return allForYouSessions.value;
  }
  return allForYouSessions.value.filter(
    (session) => session.tag === selectedTag.value
  );
});
</script>

<style scoped>
.custom-scroll-bar::-webkit-scrollbar {
  display: none;
}
.custom-scroll-bar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
